import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import "./VehicleServiceHistory.css";
import PopupMessage from "../PopupMessage/PopupMessage";
import { fetchPilotsAndVehicles, addVehicleServiceHistory, viewVehicleServiceHistory } from "../Apis/AdminApis";
import {
  FiCalendar,
  FiTruck,
  FiTool,
  FiInfo,
  FiRefreshCw,
  FiChevronLeft,
  FiChevronRight,
  FiUser,
  FiFileText,
  FiPlus,
  FiMapPin,
  FiActivity,
  FiBarChart2,
  FiArrowLeft,
FiEdit2,
} from "react-icons/fi";
import { PiDroneBold } from "react-icons/pi";
import pavamanLogo from "../images/drone.png";
import { useNavigate, useLocation } from "react-router-dom";

const VehicleServiceHistory = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // State variables
  const [vehicles, setVehicles] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [serviceHistory, setServiceHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("info");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isPaginationLoading, setIsPaginationLoading] = useState(false);
  
  // Form data for adding service
  const [formData, setFormData] = useState({
    service_date: "",
    serviced_by: "",
    remarks: ""
  });
  
  // Adding service state
  const [addingService, setAddingService] = useState(false);
const [editingRecord, setEditingRecord] = useState(null);
  useEffect(() => {
    loadVehicles();
  }, []);

  // Check for vehicle_id in URL params
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const vehicleIdFromUrl = params.get('vehicle');
    if (vehicleIdFromUrl && vehicles.length > 0) {
      const vehicle = vehicles.find(v => String(v.vehicle_id) === String(vehicleIdFromUrl));
      if (vehicle) {
        setSelectedVehicle(vehicle);
        fetchServiceHistory(vehicleIdFromUrl, 1);
      }
    }
  }, [vehicles, location.search]);

  const loadVehicles = async () => {
    try {
      setLoading(true);
      const res = await fetchPilotsAndVehicles({ action: "view" });

      if (res?.error) {
        if (res.error === "Unauthorized") {
          setPopupMessage("Session expired, redirecting to login page");
          setPopupType("error");
          setPopupOpen(true);
          setTimeout(() => navigate("/login"), 2000);
          setLoading(false);
          return;
        }
        setPopupMessage(res.error);
        setPopupType("error");
        setPopupOpen(true);
        setLoading(false);
        return;
      }

      let vehiclesArray = [];
      if (res.vehicles && Array.isArray(res.vehicles)) {
        vehiclesArray = res.vehicles;
      } else if (Array.isArray(res)) {
        vehiclesArray = res;
      } else if (res.data && Array.isArray(res.data)) {
        vehiclesArray = res.data;
      }

      const formattedVehicles = vehiclesArray.map(vehicle => ({
        vehicle_id: vehicle.vehicle_id,
        vehicle_name: vehicle.vehicle_name || vehicle.name || `Vehicle ${vehicle.vehicle_id}`,
        uin: vehicle.uin || "",
        registered_date: vehicle.registered_date,
        admin_name: vehicle.admin_name,
        mission_count: Number(vehicle.mission_count) || 0,
        max_missions_allowed: Number(vehicle.max_missions_allowed) || 0
      }));

      setVehicles(formattedVehicles);
      
    } catch (error) {
      console.error("Error loading vehicles:", error);
      setPopupMessage("Failed to load vehicles data");
      setPopupType("error");
      setPopupOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const fetchServiceHistory = async (vehicleId, page = 1) => {
    if (!vehicleId || String(vehicleId).trim() === "") {
      setPopupMessage("Invalid vehicle ID. Please try again.");
      setPopupType("error");
      setPopupOpen(true);
      return;
    }

    try {
      setHistoryLoading(true);
      const payload = {
        vehicle_id: String(vehicleId),
        page: Number(page),
        page_size:10
      };

      const res = await viewVehicleServiceHistory(payload);

      if (res?.error) {
        if (res.error === "Unauthorized") {
          setPopupMessage("Session expired, redirecting to login page");
          setPopupType("error");
          setPopupOpen(true);
          setTimeout(() => navigate("/login"), 2000);
          return;
        }
        setPopupMessage(res.error);
        setPopupType("error");
        setPopupOpen(true);
        setServiceHistory([]);
        return;
      }

      const historyData = res.history || [];
      setServiceHistory(historyData);

      if (res.pagination) {
        setCurrentPage(res.pagination.current_page || page);
        setTotalPages(res.pagination.total_pages || 1);
        setTotalRecords(res.pagination.total_records || 0);
      }

    } catch (error) {
      console.error("Error fetching service history:", error);
      setPopupMessage("Failed to fetch service history. Please try again.");
      setPopupType("error");
      setPopupOpen(true);
      setServiceHistory([]);
    } finally {
      setHistoryLoading(false);
    }
  };

const handleAddService = async () => {

  if (!formData.service_date) {
    setPopupMessage("Please select service date");
    setPopupType("error");
    setPopupOpen(true);
    return;
  }

  if (!formData.serviced_by.trim()) {
    setPopupMessage("Please enter serviced by");
    setPopupType("error");
    setPopupOpen(true);
    return;
  }

  if (!selectedVehicle || !selectedVehicle.vehicle_id) {
    setPopupMessage("No vehicle selected");
    setPopupType("error");
    setPopupOpen(true);
    return;
  }

  try {

    setAddingService(true);

    const payload = {
      action: editingRecord ? "edit" : "add",

      vehicle_id: selectedVehicle.vehicle_id,

      history_id: editingRecord?.id,

      service_date: formData.service_date,

      serviced_by: formData.serviced_by.trim(),

      remarks: formData.remarks || ""
    };

    console.log("Payload:", payload);

    const res = await addVehicleServiceHistory(payload);

    if (res?.error) {

      if (res.error === "Unauthorized") {

        setPopupMessage("Session expired, redirecting to login page");

        setPopupType("error");

        setPopupOpen(true);

        setTimeout(() => navigate("/login"), 2000);

        return;
      }

      setPopupMessage(res.error);

      setPopupType("error");

      setPopupOpen(true);

      return;
    }

    setPopupMessage(
      res.message ||
      (editingRecord
        ? "Service history updated successfully"
        : "Service history added successfully")
    );

    setPopupType("success");

    setPopupOpen(true);

    setShowAddModal(false);

    setEditingRecord(null);

    setFormData({
      service_date: "",
      serviced_by: "",
      remarks: ""
    });

    await fetchServiceHistory(selectedVehicle.vehicle_id, 1);

  } catch (error) {

    console.error("Error adding/updating service:", error);

    setPopupMessage(
      error.response?.data?.error ||
      "Failed to save service history"
    );

    setPopupType("error");

    setPopupOpen(true);

  } finally {

    setAddingService(false);
  }
};

const handleEditService = (record) => {

  setEditingRecord(record);

  setFormData({
    service_date: record.service_date || "",
    serviced_by: record.serviced_by || "",
    remarks: record.remarks || ""
  });

  setShowAddModal(true);
};

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages && selectedVehicle) {
      setIsPaginationLoading(true);
      fetchServiceHistory(selectedVehicle.vehicle_id, newPage);
      setTimeout(() => setIsPaginationLoading(false), 500);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    } catch {
      return dateString;
    }
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch {
      return dateString;
    }
  };

  const getMissionPercentage = () => {
    if (!selectedVehicle || !selectedVehicle.max_missions_allowed) return 0;
    return Math.min((selectedVehicle.mission_count / selectedVehicle.max_missions_allowed) * 100, 100);
  };

  const getMissionStatusClass = () => {
    const percentage = getMissionPercentage();
    if (percentage >= 100) return 'vsh-mission-critical';
    if (percentage >= 80) return 'vsh-mission-warning';
    return 'vsh-mission-normal';
  };

  return (
    <div className="dashboard-wrapper">
      <Sidebar />
      
      <PopupMessage
        isOpen={popupOpen}
        onClose={() => setPopupOpen(false)}
        message={popupMessage}
        type={popupType}
      />

      <div className="dashboard-content">
        {/* Header */}
      <div className="vsh-header-section">
  <div className="vsh-header-title">
    <div className="vsh-header-text">
      <h1 className="dashboard-title">Vehicle Service History</h1>
      <p className="vsh-header-subtitle">
        Track and manage maintenance records for your drone fleet
      </p>
    </div>
  </div>

  <button
    className="vsh-back-btn"
    onClick={() => navigate("/admin/pilots/vehicles")}
  >
    <FiArrowLeft size={18} />
    Back
  </button>
</div>

        {/* Vehicle Information Card - Streamlined */}
        {selectedVehicle ? (
          <div className="vsh-vehicle-info-card">
            <div className="vsh-vehicle-header">
              <div className="vsh-vehicle-icon">
                <PiDroneBold size={28} />
              </div>
              <div className="vsh-vehicle-details">
                <h2>{selectedVehicle.vehicle_name}</h2>
                <div className="vsh-vehicle-meta">
                  <span className="vsh-vehicle-id-badge">
                    ID: {selectedVehicle.vehicle_id}
                  </span>
                  {selectedVehicle.uin && (
                    <span className="vsh-vehicle-uin-badge">
                      <FiMapPin size={12} />
                      {selectedVehicle.uin}
                    </span>
                  )}
                </div>
              </div>
            </div>
            
            <div className="vsh-vehicle-stats">
              <div className="vsh-stat-item">
                <FiActivity className="vsh-stat-icon-sm" />
                <div className="vsh-stat-info-sm">
                  <span className="vsh-stat-label-sm">Missions</span>
                  <strong className="vsh-stat-value-sm">{selectedVehicle.mission_count || 0} / {selectedVehicle.max_missions_allowed || '∞'}</strong>
                </div>
              </div>
            </div>

            {/* {selectedVehicle.max_missions_allowed > 0 && (
              <div className="vsh-mission-progress">
                <div className="vsh-progress-bar">
                  <div 
                    className={`vsh-progress-fill ${getMissionStatusClass()}`}
                    style={{ width: `${getMissionPercentage()}%` }}
                  ></div>
                </div>
              </div>
            )} */}
          </div>
        ) : (
          <div className="vsh-empty-vehicle-card">
            <div className="vsh-empty-icon-large">🚁</div>
            <h3>No Vehicle Selected</h3>
            <p>Please select a vehicle from the vehicles list to view its service history</p>
          </div>
        )}

        {/* Add Service Button - Improved */}
        {selectedVehicle && (
          <div className="vsh-add-service-wrapper">
            <button
              className="vsh-add-service-btn"
              onClick={() => setShowAddModal(true)}
            >
              <FiPlus size={18} />
              Add New Service Record
            </button>
          </div>
        )}

        {/* Service History Table */}
        {selectedVehicle ? (
          <>
            <div className="vsh-table-container">
              {historyLoading ? (
                <div className="pv-loading-state">
            <img src={pavamanLogo} alt="Loading" className="pv-loading-logo" />
            <p>Loading Service History...</p>
          </div>
              ) : serviceHistory.length === 0 ? (
                <div className="vsh-empty-state">
                  <div className="vsh-empty-icon">🔧</div>
                  <h3>No service records found</h3>
                  <p>Click "Add New Service Record" to log maintenance for this vehicle</p>
                </div>
              ) : (
                <>
                  {/* <div className="vsh-records-count">
                    Showing {((currentPage - 1) * 10) + 1} - {Math.min(currentPage * 10, totalRecords)} of {totalRecords} records
                  </div> */}
                  <div className="tr-table-container">
                    <table className="tr-table">
                      <thead className="tr-thead">
                        <tr>
                          <th>S.No</th>
                          <th>Service Date</th>
                          <th>Serviced By</th>
                          <th>Missions</th>
                          <th>Remarks</th>
                          <th>Created At</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {serviceHistory.map((record, index) => (
                          <tr key={record.id || index}>
                            <td>{((currentPage - 1) * 10) + index + 1}</td>
                            <td>
                              <div className="vsh-date-cell">
                                <FiCalendar size={14} />
                                {formatDate(record.service_date)}
                              </div>
                            </td>
                            <td>
                              {record.serviced_by ? (
                                <div className="vsh-tech-cell">
                                  <FiUser size={14} />
                                  {record.serviced_by}
                                </div>
                              ) : (
                                "—"
                              )}
                            </td>
                            <td>
                              <span className="vsh-missions-badge">
                                {record.mission_count_at_service || 0} missions
                              </span>
                            </td>
                            <td className="vsh-remarks-cell">
                              {record.remarks ? (
                                <div className="vsh-remarks-tooltip" title={record.remarks}>
                                  {record.remarks.length > 50 ? record.remarks.substring(0, 50) + "..." : record.remarks}
                                </div>
                              ) : (
                                "—"
                              )}
                            </td>
                            <td className="vsh-date-small">
                              {formatDateTime(record.created_at)}
                            </td>
                            <td>
  <button
    className="vsh-edit-btn"
    onClick={() => handleEditService(record)}
  >
    <FiEdit2 size={14} />
    Edit
  </button>
</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>

            {/* Pagination - Using same classnames as AllFlights */}
            {totalPages > 1 && !historyLoading && serviceHistory.length > 0 && (
              <div className="pv-pilot-pagination-wrapper">
                <div className="pv-pilot-pagination-controls">
                  <button
                    className="pv-pilot-pagination-btn"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1 || isPaginationLoading}
                  >
                    <FiChevronLeft size={16} />
                    Previous
                  </button>
                  
                  <div className="pv-pilot-page-numbers">
                    {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                      let pageNumber;
                      if (totalPages <= 5) {
                        pageNumber = i + 1;
                      } else if (currentPage <= 3) {
                        pageNumber = i + 1;
                      } else if (currentPage >= totalPages - 2) {
                        pageNumber = totalPages - 4 + i;
                      } else {
                        pageNumber = currentPage - 2 + i;
                      }
                      
                      return (
                        <button
                          key={pageNumber}
                          className={`pv-pilot-page-btn ${currentPage === pageNumber ? 'pv-pilot-active' : ''}`}
                          onClick={() => handlePageChange(pageNumber)}
                          disabled={isPaginationLoading}
                        >
                          {pageNumber}
                        </button>
                      );
                    })}
                  </div>
                  
                  <button
                    className="pv-pilot-pagination-btn"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages || isPaginationLoading}
                  >
                    Next
                    <FiChevronRight size={16} />
                  </button>
                </div>
              </div>
            )}
          </>
        ) : null}
      </div>

      {/* Add Service Modal - Fully Responsive */}
      {showAddModal && selectedVehicle && (
        <div className="vsh-modal-overlay" onClick={() => {
  setShowAddModal(false);
  setEditingRecord(null);

  setFormData({
    service_date: "",
    serviced_by: "",
    remarks: ""
  });
}}>
          <div className="vsh-modal" onClick={(e) => e.stopPropagation()}>
            <div className="vsh-modal-header">
             <h2>
  <FiTool size={20} />
  {editingRecord ? "Edit Service Record" : "Add Service Record"}
</h2>
              <button className="vsh-modal-close" onClick={() => {
  setShowAddModal(false);
  setEditingRecord(null);

  setFormData({
    service_date: "",
    serviced_by: "",
    remarks: ""
  });
}}>
                ×
              </button>
            </div>

            <div className="vsh-modal-body">
              <div className="vsh-service-info-banner">
                <FiInfo size={16} />
                <span>Adding a service record will be associated with this vehicle's maintenance history</span>
              </div>

              <div className="vsh-vehicle-preview-mini">
                <div className="vsh-preview-icon">
                  <PiDroneBold size={20} />
                </div>
                <div className="vsh-preview-info">
                  <strong>{selectedVehicle.vehicle_name}</strong>
                  <span>ID: {selectedVehicle.vehicle_id}</span>
                </div>
              </div>

              <div className="vsh-form-group">
                <label className="vsh-form-label">
                  <FiCalendar size={14} />
                  Service Date <span className="vsh-required">*</span>
                </label>
                <input
                  type="date"
                  className="vsh-form-input"
                  value={formData.service_date}
                  onChange={(e) => setFormData({ ...formData, service_date: e.target.value })}
                  max={new Date().toISOString().split('T')[0]}
                />
              </div>

              <div className="vsh-form-group">
                <label className="vsh-form-label">
                  <FiUser size={14} />
                  Serviced By <span className="pv-required">*</span>
                </label>
                <input
                  type="text"
                  className="vsh-form-input"
                  placeholder="Enter technician name or service center"
                  value={formData.serviced_by}
                  onChange={(e) => setFormData({ ...formData, serviced_by: e.target.value })}
                />
              </div>

              <div className="vsh-form-group">
                <label className="vsh-form-label">
                  <FiFileText size={14} />
                  Remarks
                </label>
                <textarea
                  className="vsh-form-textarea"
                  placeholder="Enter any additional notes about the service..."
                  value={formData.remarks}
                  onChange={(e) => setFormData({ ...formData, remarks: e.target.value })}
                  rows="3"
                />
              </div>

              <div className="vsh-mission-stats-mini">
                <div className="vsh-mission-item">
                  <span>Missions Completed:</span>
                  <strong>{selectedVehicle.mission_count || 0}</strong>
                </div>
                <div className="vsh-mission-item">
                  <span>Max Missions Allowed:</span>
                  <strong>{selectedVehicle.max_missions_allowed || '∞'}</strong>
                </div>
              </div>
            </div>

            <div className="vsh-modal-footer">
              <button className="vsh-btn vsh-btn-secondary" onClick={() => {
  setShowAddModal(false);
  setEditingRecord(null);

  setFormData({
    service_date: "",
    serviced_by: "",
    remarks: ""
  });
}}>
                Cancel
              </button>
              <button
                className="vsh-btn vsh-btn-primary"
                onClick={handleAddService}
                disabled={addingService || !formData.service_date}
              >
              {addingService
  ? (editingRecord ? "Updating..." : "Adding...")
  : (editingRecord ? "Update Service Record" : "Add Service Record")
}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VehicleServiceHistory;